const keys = {
	CONNECT_ISSUE: 'connect-issue',
	BITBUCKET_ISSUE: 'bitbucket-issue',
	CORE_ISSUE: 'core-issue',
	MOBILE_ISSUE: 'mobile-issue',
	SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
	SOFTWARE_ISSUE: 'software-issue',
	STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
	SERVICE_DESK: 'service-desk',
	EMPTY_APPLICATION_KEY: '',
} as const;

export type ApplicationKey =
	| typeof keys.CONNECT_ISSUE
	| typeof keys.BITBUCKET_ISSUE
	| typeof keys.CORE_ISSUE
	| typeof keys.MOBILE_ISSUE
	| typeof keys.SIMPLE_SOFTWARE_BOARD
	| typeof keys.STANDARD_ROADMAP_ISSUE
	| typeof keys.SOFTWARE_ISSUE
	| typeof keys.SERVICE_DESK
	| typeof keys.EMPTY_APPLICATION_KEY;

export default keys;
